import './App.css';
import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import AppRoutes from './AppRoutes';
// import {Provider} from 'react-redux';
// import {ThemeProvider, CssBaseline} from '@mui/material';
// import ReactDOM from "react-dom/client";

function App() {
  return (
      <BrowserRouter>
          <AppRoutes/>
        </BrowserRouter>
  );
}

export default App;
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<App />);
